import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useUserStore } from '../../components/userStore';

const Funds = () => {
	const { user } = useUserStore();
	const fundsQuery = useQuery({
		queryKey: ['fundsList', user.coord_agency_id],
		queryFn: async () => {
			const { data } = await axios.get(
				`coord_agencies/${user.coord_agency_id}/funds`,
			);
			return data;
		},
	});
	return (
		<>
			<div className="breadcrumbs">
				<ul>
					<li>
						<Link to="/" className="link">
							Home
						</Link>
					</li>
					<li>Funds</li>
				</ul>
			</div>
			<div className="clear-both px-4 py-4 mt-2 bg-white rounded-lg">
				<div className="flex items-center justify-between">
					<h2>Funds Management</h2>
					<Link className="btn btn-primary" to="/funds/add">
						Add Fund
					</Link>
				</div>
				<div className="divider" />
				<table className="table w-full">
					<thead>
						<tr>
							<th>Acct. Number</th>
							<th>Name</th>
							<th>Description</th>
						</tr>
					</thead>
					<tbody>
						{fundsQuery.isLoading ? (
							<tr>
								<td colSpan="3">Loading...</td>
							</tr>
						) : fundsQuery.isError ? (
							<tr>
								<td colSpan="3">Error loading funds</td>
							</tr>
						) : (
							fundsQuery.data.map((fund) => (
								<tr key={`${fund.id}`}>
									<td>{fund.acct_num}</td>
									<td>{fund.name}</td>
									<td>{fund.description}</td>
									<td>
										<Link
											to={`/funds/${fund.id}`}
											className="btn btn-primary btn-sm"
										>
											Edit
										</Link>
									</td>
								</tr>
							))
						)}
					</tbody>
				</table>
			</div>
		</>
	);
};

export default Funds;
